import { render } from "./queues.vue?vue&type=template&id=65ab0d46&scoped=true"
import script from "./queues.vue?vue&type=script&lang=js"
export * from "./queues.vue?vue&type=script&lang=js"

import "./queues.vue?vue&type=style&index=0&id=65ab0d46&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ab0d46"]])

export default __exports__